import { h } from "preact";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import AccessControl from "../../components/AccessControl";
import AuthControl from "../../components/AuthControl";


export default function MainLayout() {

    return (
        <AuthControl>
            <Layout className="layout">
                <Sidebar />
                <Layout>
                    <Header />
                    <Layout.Content>
                        <AccessControl>
                            <Outlet />
                        </AccessControl>
                    </Layout.Content>
                </Layout>
            </Layout>
        </AuthControl>
    );
}